import { createSlice } from "@reduxjs/toolkit";
import { menuItems } from "../../Layouts/json/menu";
const initialState = {
  menu: [],
  menuList: menuItems,
};
const moduleAccessTree = createSlice({
  name: "moduleaccesstree",
  initialState: initialState,
  reducers: {
    setModuleAccessTree: (state, action) => {
      state.menu = action.payload;
    },
  },
});
export const { setModuleAccessTree } = moduleAccessTree.actions;
export default moduleAccessTree.reducer;
